import { FC, useState } from "react";
import Image from "next/legacy/image";
import { P1 } from "../atoms/Paragraph";
import { H2 } from "../atoms/Heading";
import styled, { ThemeContext } from "styled-components";
import { Button } from "../atoms/Button";
import { StandardSection } from "../templates/StandardSection";
import { tablet } from "../templates/Breakpoints";
import { Spacer } from "../templates/Spacer";
import { Avatar } from "../atoms/Avatar";
import CloudsSvg from "../../public/static/img/rebrand/svgs/Clouds.svg";
import DrChatterjee from "../../public/static/img/rebrand/rangan-chatterjee.png";

export const ChatterjeeTestimonial: FC<{
  id?: string;
  pt?: string;
  pb?: string;
}> = ({ id = "chatterjee-testimonial", pt, pb }) => {
  return (
    <section id={id}>
      <StandardSection
        background="linear-gradient(180deg, rgba(244, 240, 255, 0) 0%, #F4F0FF 50%)"
        pt={pt}
        pb="0"
      >
        <Flex>
          <FlexText>
            <H2>Meet Dr. Rangan Chatterjee - Our Chief Wellbeing Officer</H2>
            <P1>
              We believe small steps can create lasting impact. That’s why we’re working with Dr.
              Chatterjee to create a balanced wellbeing approach that inspires long-term healthy
              habits for your team.
            </P1>
            <CTAFlex>
              <ThemeContext.Consumer>
                {(props) => {
                  return (
                    <div
                      onMouseEnter={() => {
                        props?.preloadVideo("470168090");
                      }}
                    >
                      <WatchVideoButton onClick={() => props?.triggerVideo()}>
                        Watch the video
                      </WatchVideoButton>
                    </div>
                  );
                }}
              </ThemeContext.Consumer>
            </CTAFlex>
          </FlexText>
          <FlexImage>
            <Clouds>
              <Image src={CloudsSvg} alt="Clouds" />
            </Clouds>
            <Chatterjee>
              <Image
                src={DrChatterjee}
                alt="Dr Rangan Chatterjee, Chief Wellbeing Officer at YuLife"
                height={930}
                width={635}
              />
            </Chatterjee>
          </FlexImage>
        </Flex>
      </StandardSection>
      <StandardSection background={"#956AFF"} pt="0" pb="0">
        <Spacer height={["7.5rem", "5rem", "2.5rem"]} />
        <MaxWidth>
          <H2 color="white">
            “By offering tangible rewards for healthy behaviour, YuLife helps us develop habits that
            will make a lasting difference to our lifestyles.”
          </H2>
          <Attribution>
            <StyledAvatar
              path="/img/rebrand/avatars/Rangan.jpg"
              alt="Dr Rangan Chatterjee, Chief Wellbeing Officer at YuLife"
            />
            <P1 pt="0" color="white">
              Dr. Chatterjee, Chief Wellbeing Officer <strong>YuLife</strong>
            </P1>
          </Attribution>
        </MaxWidth>
        <Spacer height={["7.5rem", "5rem", "2.5rem"]} />
      </StandardSection>
      <Spacer height={pb || "7.5rem"} />
    </section>
  );
};

const Flex = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;

  ${tablet} {
    display: block;
  }
`;

const FlexImage = styled.div`
  flex: 1 0 100px;
  display: flex;
  margin-left: -6vw;
`;

const Clouds = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 55vw;
  max-width: 70rem;
  display: flex;
  align-items: flex-end;
`;

const Chatterjee = styled.div`
  align-self: flex-end;
  display: flex;
  align-items: flex-end;
  position: relative;

  @media only screen and (max-width: 80rem) {
    transform: translateX(-2vw);
  }

  ${tablet} {
    transform: translateX(2vw);
  }
`;

const FlexText = styled.div`
  flex: 1 1 100px;
  background: none;
  margin: 7.5rem 0 7.5rem 8rem;
  position: relative;
  z-index: 1;

  @media only screen and (max-width: 90rem) {
    margin-left: 8.8vw;
  }

  @media only screen and (max-width: 80rem) {
    margin-top: 0;
    margin-left: 0;
  }

  ${tablet} {
    margin: 0 0 2.5rem;
  }
`;

const WatchVideoButton = styled(Button)`
  margin: 3rem 2.4rem 0 0;

  @media only screen and (max-width: 39rem) {
    margin: 32px 0 0 0;
  }
`;

const MaxWidth = styled.div`
  max-width: 58rem;
  margin: auto;
`;

const Attribution = styled.div`
  display: flex;
  align-items: center;
  padding-top: 2rem;
`;

const StyledAvatar = styled(Avatar)`
  width: 4rem;
  height: 4rem;
  flex-shrink: 0;
  margin: 0 1.5rem 0 0;
`;

const CTAFlex = styled.div`
  display: flex;
  flex-direction: row;

  @media only screen and (max-width: 39rem) {
    flex-direction: column;
  }
`;
